// Locale-dependent error message overrides for the shared HttpService.
// EAS uses the English defaults; the Polish frontend calls
// configureHttpServiceMessages() at startup with PL strings.

export type HttpServiceMessages = {
    somethingWentWrong: (error: unknown) => string;
    serverUnavailable: string;
};

let messages: HttpServiceMessages = {
    somethingWentWrong: (error) => `Something went wrong: ${error}`,
    serverUnavailable: 'Server is temporarily unavailable. Please try again in a moment.',
};

export function configureHttpServiceMessages(m: Partial<HttpServiceMessages>) {
    messages = {...messages, ...m};
}

export function getHttpServiceMessages(): HttpServiceMessages {
    return messages;
}
